const RU_CLASS_REFERENCE_PAGES = {
  barbarian: "https://pathfinder.family/class/barbarian",
  bard: "https://pathfinder.family/class/bard",
  cleric: "https://pathfinder.family/class/cleric",
  druid: "https://pathfinder.family/class/druid",
  fighter: "https://pathfinder.family/class/fighter",
  monk: "https://pathfinder.family/class/monk",
  paladin: "https://pathfinder.family/class/paladin",
  ranger: "https://pathfinder.family/class/ranger",
  rogue: "https://pathfinder.family/class/rogue",
  sorcerer: "https://pathfinder.family/class/sorcerer",
  wizard: "https://pathfinder.family/class/wizard",
};

const RU_RACE_REFERENCE_PAGES = {
  human: "https://pathfinder.family/race/human",
  elf: "https://pathfinder.family/race/elf",
  dwarf: "https://pathfinder.family/race/dwarf",
  gnome: "https://pathfinder.family/race/gnome",
  halfling: "https://pathfinder.family/race/halfling",
  "half-elf": "https://pathfinder.family/race/halfElf",
  "half-orc": "https://pathfinder.family/race/halfOrc",
};

// Exact headings used by Pathfinder Family in the detailed class descriptions.
// They intentionally do not reuse our UI translations: even a small wording
// difference prevents the browser's text-fragment navigation from finding the
// right paragraph.
export const RU_CLASS_PASSIVE_ANCHORS = {
  "class-barbarian-rage": "Ярость (Экс):",
  "class-barbarian-fast-movement": "Быстрое перемещение (Экс):",
  "class-barbarian-rage-power": "Дары ярости (Экс):",
  "class-barbarian-uncanny-dodge": "Невероятное уклонение (Экс):",
  "class-barbarian-trap-sense": "Чутье на ловушки (Экс):",
  "class-barbarian-improved-uncanny-dodge": "Невероятное уклонение+ (Экс):",
  "class-barbarian-damage-reduction": "Снижение урона (Экс):",
  "class-barbarian-greater-rage": "Бешеная ярость (Экс):",
  "class-barbarian-indomitable-will": "Несокрушимая воля (Экс):",
  "class-barbarian-tireless-rage": "Безмерная ярость (Экс):",
  "class-barbarian-mighty-rage": "Сокрушительная ярость (Экс):",

  "class-bard-bardic-knowledge": "Эрудиция барда (Экс):",
  "class-bard-bardic-performance": "Выступление барда:",
  "class-bard-cantrips": "Фокусы:",
  "class-bard-versatile-performance": "Прикладное искусство (Экс):",
  "class-bard-well-versed": "Музыкальный слух (Экс):",
  "class-bard-lore-master": "Хранитель знаний (Экс):",
  "class-bard-jack-of-all-trades": "Мастер на все руки (Экс):",
  "class-bard-spellcasting": "Заклинания:",
  "class-bard-countersong": "Контрпесня (Св):",
  "class-bard-distraction": "Отвлечение (Св):",
  "class-bard-fascinate": "Завораживание (Св):",
  "class-bard-inspire-courage": "Песнь отваги (Св):",
  "class-bard-inspire-competence": "Песнь мастерства (Св):",
  "class-bard-suggestion": "Внушение (Пс):",
  "class-bard-dirge-of-doom": "Погребальная песнь (Св):",
  "class-bard-inspire-greatness": "Боевое вдохновение (Св):",
  "class-bard-soothing-performance": "Целительное искусство (Св):",
  "class-bard-frightening-tune": "Пугающая мелодия (Пс):",
  "class-bard-inspire-heroics": "Героическое воодушевление (Св):",
  "class-bard-mass-suggestion": "Массовое внушение (Пс):",
  "class-bard-deadly-performance": "Смертельное искусство (Св):",

  "class-cleric-aura": "Аура (Экс):",
  "class-cleric-channel-energy": "Божественная сила (Св):",
  "class-cleric-domains": "Сферы:",
  "class-cleric-orisons": "Молитвы:",
  "class-cleric-spontaneous-casting": "Спонтанное сотворение:",
  "class-cleric-spellcasting": "Заклинания:",

  "class-druid-nature-bond": "Связь с природой (Экс):",
  "class-druid-nature-sense": "Чувство природы (Экс):",
  "class-druid-orisons": "Молитвы:",
  "class-druid-wild-empathy": "Понимание животных (Экс):",
  "class-druid-woodland-stride": "В лесу как дома (Экс):",
  "class-druid-trackless-step": "Тайные тропы (Экс):",
  "class-druid-resist-natures-lure": "Неподвластный природе (Экс):",
  "class-druid-wild-shape": "Природный облик (Св):",
  "class-druid-venom-immunity": "Невосприимчивость к ядам (Экс):",
  "class-druid-a-thousand-faces": "Тысяча лиц (Св):",
  "class-druid-timeless-body": "Нестареющее тело (Экс):",
  "class-druid-spellcasting": "Заклинания:",
  "class-druid-druidic": "Дополнительные языки:",
  "class-druid-spontaneous-casting": "Спонтанное сотворение:",

  "class-fighter-bonus-feat": "Дополнительная черта:",
  "class-fighter-bravery": "Храбрость (Экс):",
  "class-fighter-armor-training": "Мастерство ношения брони (Экс):",
  "class-fighter-weapon-training": "Мастерство владения оружием (Экс):",
  "class-fighter-armor-mastery": "Истинный мастер брони (Экс):",
  "class-fighter-weapon-mastery": "Истинный мастер оружия (Экс):",

  "class-monk-bonus-feat": "Дополнительная черта:",
  "class-monk-flurry": "Град ударов (Экс):",
  "class-monk-stunning-fist": "Шокирующий кулак (Экс):",
  "class-monk-unarmed-strike": "Мастер кулачного боя:",
  "class-monk-evasion": "Уклонение (Экс):",
  "class-monk-fast-movement": "Быстрое перемещение (Экс):",
  "class-monk-maneuver-training": "Отточенные маневры (Экс):",
  "class-monk-still-mind": "Непоколебимый разум (Экс):",
  "class-monk-ki-pool": "Запас энергии ци (Св):",
  "class-monk-purity-of-body": "Чистота тела (Экс):",
  "class-monk-wholeness-of-body": "Целостность тела (Св):",
  "class-monk-improved-evasion": "Уклонение+ (Экс):",
  "class-monk-diamond-body": "Алмазное тело (Св):",
  "class-monk-abundant-step": "Беспрепятственный шаг (Св):",
  "class-monk-diamond-soul": "Алмазная душа (Экс):",
  "class-monk-quivering-palm": "Дрожащая ладонь (Св):",
  "class-monk-timeless-body": "Нестареющее тело (Экс):",
  "class-monk-tongue-sun-moon": "Язык луны и солнца (Экс):",
  "class-monk-empty-body": "Пустое тело (Св):",
  "class-monk-perfect-self": "Совершенство:",
  "class-monk-ac-bonus": "Бонус к КБ (Экс):",
  "class-monk-slow-fall": "Замедление падения (Экс):",
  "class-monk-high-jump": "Высокий прыжок (Экс):",

  "class-paladin-aura-good": "Аура добра (Экс):",
  "class-paladin-detect-evil": "Определение мировоззрения: зло (Пс):",
  "class-paladin-smite-evil": "Сокрушение зла (Св):",
  "class-paladin-divine-grace": "Милость божества (Св):",
  "class-paladin-lay-on-hands": "Возложение рук (Св):",
  "class-paladin-aura-courage": "Аура доблести (Св):",
  "class-paladin-divine-health": "Божественное здоровье (Экс):",
  "class-paladin-mercy": "Избавление (Св):",
  "class-paladin-channel-positive": "Божественная сила (Св):",
  "class-paladin-divine-bond": "Связь с божеством (Пс):",
  "class-paladin-spellcasting": "Заклинания:",
  "class-paladin-aura-resolve": "Аура решимости (Св):",
  "class-paladin-aura-justice": "Аура справедливости (Св):",
  "class-paladin-aura-faith": "Аура веры (Св):",
  "class-paladin-aura-righteousness": "Аура праведности (Св):",
  "class-paladin-holy-champion": "Ревнитель веры (Св):",

  "class-ranger-favored-enemy": "Заклятый враг (Экс):",
  "class-ranger-track": "Выслеживание (Экс):",
  "class-ranger-wild-empathy": "Понимание животных (Экс):",
  "class-ranger-combat-style": "Черта боевого стиля (Экс):",
  "class-ranger-endurance": "Двужильный:",
  "class-ranger-favored-terrain": "Излюбленная местность (Экс):",
  "class-ranger-hunters-bond": "Совместная охота (Экс):",
  "class-ranger-woodland-stride": "В лесу как дома (Экс):",
  "class-ranger-swift-tracker": "Ищейка (Экс):",
  "class-ranger-evasion": "Уклонение (Экс):",
  "class-ranger-quarry": "Добыча (Экс):",
  "class-ranger-camouflage": "Камуфляж (Экс):",
  "class-ranger-hide-plain-sight": "Мастер незаметности (Экс):",
  "class-ranger-improved-evasion": "Уклонение+ (Экс):",
  "class-ranger-improved-quarry": "Добыча+ (Экс):",
  "class-ranger-master-hunter": "Великий охотник (Экс):",
  "class-ranger-spellcasting": "Заклинания:",

  "class-rogue-sneak-attack": "Атака исподтишка:",
  "class-rogue-trapfinding": "Поиск ловушек:",
  "class-rogue-evasion": "Уклонение (Экс):",
  "class-rogue-talent": "Воровские приемы:",
  "class-rogue-trap-sense": "Чутье на ловушки (Экс):",
  "class-rogue-uncanny-dodge": "Невероятное уклонение (Экс):",
  "class-rogue-improved-uncanny-dodge": "Невероятное уклонение+ (Экс):",
  "class-rogue-advanced-talent": "Продвинутые приемы:",
  "class-rogue-master-strike": "Мастерский удар (Экс):",
  "class-rogue-advanced-talents": "Продвинутые приемы:",

  "class-sorcerer-bloodline": "Наследие:",
  "class-sorcerer-cantrips": "Фокусы:",
  "class-sorcerer-bloodline-power": "Наследие:",
  "class-sorcerer-bloodline-spell": "Наследие:",
  "class-sorcerer-bloodline-feat": "Наследие:",
  "class-sorcerer-spellcasting": "Заклинания:",
  "class-sorcerer-eschew-materials": "Заклинания без реагентов:",

  "class-wizard-arcane-bond": "Мистическая связь (Пс) или (Экс):",
  "class-wizard-arcane-school": "Школа магии:",
  "class-wizard-cantrips": "Фокусы:",
  "class-wizard-scribe-scroll": "Написание свитков::",
  "class-wizard-bonus-feat": "Дополнительная черта:",
  "class-wizard-spellcasting": "Заклинания:",
  "class-wizard-spellbook": "Книги заклинаний:",
};

export const RU_RACE_PASSIVE_ANCHORS = {
  "human-ability-score": "+2 к значению одной характеристики",
  "human-bonus-feat": "Дополнительная черта",
  "human-skilled": "Умелый",
  "elf-immunities": "Эльфийский иммунитет",
  "elf-elven-magic": "Эльфийская магия",
  "elf-keen-senses": "Острые чувства",
  "elf-weapon-familiarity": "Оружие эльфов",
  "dwarf-slow-and-steady": "Медленно, но верно",
  "dwarf-defensive-training": "Умение защищаться",
  "dwarf-greed": "Жадность",
  "dwarf-hatred": "Ненависть",
  "dwarf-hardy": "Крепкий",
  "dwarf-stability": "Непоколебимость",
  "dwarf-stonecunning": "Знание камня",
  "dwarf-weapon-familiarity": "Оружие дварфов",
  "gnome-defensive-training": "Умение защищаться",
  "gnome-magic": "Гномья магия",
  "gnome-hatred": "Ненависть",
  "gnome-illusion-resistance": "Сопротивление иллюзиям",
  "gnome-keen-senses": "Острые чувства",
  "gnome-obsessive": "Увлеченность",
  "gnome-weapon-familiarity": "Оружие гномов",
  "halfling-fearless": "Бесстрашный",
  "halfling-luck": "Удача полурослика",
  "halfling-keen-senses": "Острые чувства",
  "halfling-sure-footed": "Проворный",
  "halfling-weapon-familiarity": "Оружие полуросликов",
  "half-elf-adaptability": "Приспособляемость",
  "half-elf-elf-blood": "Смешанная кровь",
  "half-elf-elven-immunities": "Эльфийский иммунитет",
  "half-elf-keen-senses": "Острые чувства",
  "half-elf-multitalented": "Разносторонний",
  "half-orc-intimidating": "Устрашающий вид",
  "half-orc-orc-blood": "Смешанная кровь",
  "half-orc-orc-ferocity": "Орочья свирепость",
  "half-orc-weapon-familiarity": "Оружие орков",
};

export const getRussianPassiveReference = (record) => {
  const isRace = record?.origin === "race";
  const page = (isRace ? RU_RACE_REFERENCE_PAGES : RU_CLASS_REFERENCE_PAGES)[record?.sourceId];
  const anchor = (isRace ? RU_RACE_PASSIVE_ANCHORS : RU_CLASS_PASSIVE_ANCHORS)[record?.featureId];

  if (!page || !anchor) return null;

  return { page, anchor };
};

export const getRussianPassiveDisplayName = (record) => {
  const reference = getRussianPassiveReference(record);
  return reference?.anchor.replace(/:+$/, "") || "";
};
